'use client';
import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

import { stringEmptyCheck } from '@nf/utils-common/fpw/utils';
import { modalService } from '@/services/modal.service';

const MessageModal = dynamic(
	() => import('./message-modal').then(m => m.MessageModal),
	{ ssr: false }
);

export const MessageModalLoader = () => {
	const [shouldRender, setShouldRender] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [message, setMessage] = useState('');

	useEffect(() => {
		const subscription = modalService.onOpenMessageModal.subscribe(msg => {
			stringEmptyCheck(msg).fold(
				() => {},
				(validMsg: string) => {
					setMessage(validMsg);
					setShouldRender(true);
					setIsOpen(true);
				}
			);
		});

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	const closeModal = () => setIsOpen(false);

	if (!shouldRender) {
		return null;
	}

	return (
		<MessageModal 
			isOpen={isOpen} 
			message={message}
			onClose={closeModal} 
		/>
	);
};